import { IIconBase } from '..'

const producterIcon = ({
  color = '#292D32',
  height = 51,
  width = 51,
}: IIconBase) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 51 51'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g id='vuesax/linear/profile'>
        <g id='profile'>
          <path
            id='Vector'
            d='M25.8399 23.0987C25.6274 23.0775 25.3724 23.0775 25.1387 23.0987C20.0812 22.9287 16.0649 18.785 16.0649 13.685C16.0649 8.47875 20.2724 4.25 25.4999 4.25C30.7062 4.25 34.9349 8.47875 34.9349 13.685C34.9137 18.785 30.8974 22.9287 25.8399 23.0987Z'
            stroke={color}
            strokeWidth='3.5'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            id='Vector_2'
            d='M15.2148 30.94C10.0723 34.3825 10.0723 39.9925 15.2148 43.4137C21.0585 47.3237 30.6423 47.3237 36.486 43.4137C41.6285 39.9712 41.6285 34.3613 36.486 30.94C30.6635 27.0513 21.0798 27.0513 15.2148 30.94Z'
            stroke={color}
            strokeWidth='3.5'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </g>
      </g>
    </svg>
  )
}

export default producterIcon
